import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';

export default class NavbarComponent extends Component {
    @service router;

    @action
    goToBuzon() {
        this.router.transitionTo('buzon');
    }
}
